import Head from "next/head";

import BecomeADeveloperMain from "@/components/developers/become-a-developer";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function BecomeADeveloper() {
  return (
    <>
      <Head>
        <title>{seoData.DEV_BECOME_A_DEVELOPER.title}</title>
        <SeoMetaData data={seoData.DEV_BECOME_A_DEVELOPER} />
      </Head>

      <BecomeADeveloperMain />
    </>
  );
}
